import { Link } from 'react-router-dom';
import { APP_VERSION } from '../version';
import styles from './SiteFooter.module.css';

const year = new Date().getFullYear();

export function SiteFooter({
  className,
  variant = 'app',
}: {
  className?: string;
  variant?: 'app' | 'auth';
}) {
  const isAuth = variant === 'auth';

  return (
    <footer className={`${styles.footer} ${className ?? ''}`.trim()}>
      <div className={styles.footerInner}>
        <div className={styles.footerInnerLeft}>
          <span>
            &copy; {year} Craftin
          </span>
          {isAuth ? (
            <span className={styles.footerVersion}>v{APP_VERSION}</span>
          ) : (
            <Link to="/changelog" className={styles.footerVersion}>v{APP_VERSION}</Link>
          )}
        </div>
        <div className={styles.footerInnerLinks}>
          {!isAuth && (
            <>
              <Link to="/changelog">Changelog</Link>
              |&nbsp;
            </>
          )}
          <a href="https://craftin.dev/datenschutz" target="_blank" rel="noopener noreferrer">
            Privacy
          </a>
          &nbsp;|&nbsp;
          <a href="https://craftin.dev/impressum" target="_blank" rel="noopener noreferrer">
            Imprint
          </a>
        </div>
      </div>
    </footer>
  );
}
